import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {AppRoutingModule} from '../../app/app-routing.module';
import {
  NavigationComponent
} from './components';
import {ModalComponent} from './components/modal/modal.component';
import {I18NextModule} from 'angular-i18next';
import {LangSwitcherComponent} from './components/lang-switcher/lang-switcher.component';
import {SearchFilterModule} from '../search-filter/search-filter.module';
import {StatusIndicatorComponent} from './components/status-indicator/status-indicator.component';
import {LoadingComponent} from './components/loading/loading.component';
import {AppUpdateComponent} from './components/app-update/app-update.component';

@NgModule({
  declarations: [
    NavigationComponent,
    ModalComponent,
    LangSwitcherComponent,
    StatusIndicatorComponent,
    LoadingComponent,
    AppUpdateComponent
  ],
  exports: [
    ModalComponent,
    LoadingComponent,
    LangSwitcherComponent,
    AppUpdateComponent,
    StatusIndicatorComponent
  ],
  schemas: [],
  imports: [
    AppRoutingModule,
    CommonModule,
    I18NextModule,
    SearchFilterModule
  ],
  providers: []
})
export class SharedModule {
}
